export const FspCalculateMethodPolicy = ({

    ITEM_CALENDAR: "Calendar",
    ITEM_EXACT: "Exact",
    ITEM_SPLITTING: "By Splitting Day",

})